module.exports = __webpack_public_path__ + "static/media/introSecond.5c8ce40c.png";